module.exports = __webpack_public_path__ + "static/media/duration-violet.73eedf6d.svg";